// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3zWQN","itemTitle":"ClientEmergencyInfo_itemTitle__aGYXe","itemText":"ClientEmergencyInfo_itemText__2IDxF"};